module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A book covering 150 years of an event as large as the Mid-South Fair cannot be completed without the assistance and work of others. The Mid-South Fair Historical Committee has worked to preserve and document the yearly event known as the Mid-South Fair. If it was not for those who clip out the newspaper articles, collect memorabilia, and archive the photographs, we would not have the resources we have today. Donne Walden needs to be singled out for his dedication to preserving the past and recording for future generations the events of today. His willingness to assist with photographs, and most of all his first-hand memories, is most appreciated. Donne literally grew up at the fair, as his parents worked at the fairgrounds in the 1930s and were married in front of the grandstands in 1933. He worked the fairgrounds photograph booth in the 1950s and has been an active member of the historical committee for many years. Jim Johnson and his entire staff at the Memphis and Shelby County Public Library were more than helpful, and their collection of fair images helped in making the book more enjoyable. Special thanks also goes out to Dave Darnell at "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the Commercial Appeal,")]), _vm._v(" Ed Frank at the University of Memphis Special Collections, and the staff and volunteers of the Mid-South Fair. Thank you to my wife, Lisa, who was always supportive and there when I needed a comma. This could not have been done without you.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Many images used in this book came from the collection of my father, Robert William Dye. He documented a time and place during the 1940s and 1950s that is for many of us a distant memory. It is through his camera that we can see what the fair was like and through his images that we have a snapshot of a time, a place, and a feeling called the Mid-South Fair.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "39%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633502_i0004.jpg",
      "src": "images/e9781439633502_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Elvis Presley took time after his impromptu act with Dennis Day to sign autographs for the Manhattan Rockets, an all-girl singing and dancing act performing with Day as part of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stars over Dixie")]), _vm._v(" show. By September 1956, Col. Tom Parker was in full control of managing Elvis. Elvis is seen here wearing the just-released Elvis Presley tennis shoes, with the likeness of the king adorning the tops.")])])])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b76323c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633502_ack01.vue
// module id = 72
// module chunks = 0